import { exitSearch } from './actions/exitSearch';
import onNewMessage from './actions/onNewMessage';
import onPrintRow from './actions/onPrintRow';

import onListViewSelectionChange from './orchestrators/ListViewSelectionChangeOrchestrator';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { PreviewPaneSelectionSource } from 'owa-sxs-store';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
import {
    SaveReadingPanePositionOptionStitch,
    SaveReadingPanePositionOptionStitchName,
} from 'owa-reading-pane-option';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailModuleOrchestrator" */ './lazyIndex')
);

export {
    onNewMessage,
    onListViewSelectionChange,
    onPrintRow,
    PreviewPaneSelectionSource,
    exitSearch,
};

export let lazyCloseImmersiveReadingPane = new LazyAction(
    lazyModule,
    m => m.closeImmersiveReadingPane
);

export let lazyOnReplyOrReplyAllOrForwardMessage = new LazyAction(
    lazyModule,
    m => m.onReplyOrReplyAllOrForwardMessage
);

export let lazyOnSelectingFolder = new LazyAction(lazyModule, m => m.onSelectingFolder);
export let lazyOnSxSPreviewPaneClose = new LazyImport(lazyModule, m => m.onSxSPreviewPaneClose);

export let lazyOnReadingPanePositionOptionSaved = new LazyAction(
    lazyModule,
    m => m.onReadingPanePositionOptionSaved
);

export let lazyOnSelectMessageAd = new LazyAction(lazyModule, m => m.onSelectMessageAd);

// Initialize stitch to listen to action in Options that toggles Focused Inbox
runAfterInitialRender(() => {
    // Type safety without pulling in a string reference and all the code that goes with it
    const stitchName: SaveReadingPanePositionOptionStitchName =
        'saveReadingPanePositionOptionStitchName';
    subscribe<SaveReadingPanePositionOptionStitch>(stitchName, () =>
        lazyOnReadingPanePositionOptionSaved.importAndExecute()
    );
});

import './actions/onClientReadingPanePositionChangeOrchestrator';
